import { render, staticRenderFns } from "./package.vue?vue&type=template&id=62681dac&scoped=true&"
import script from "./package.vue?vue&type=script&lang=js&"
export * from "./package.vue?vue&type=script&lang=js&"
import style0 from "./package.vue?vue&type=style&index=0&id=62681dac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62681dac",
  null
  
)

export default component.exports